/**
 * Тексты приложения — дословно из ТЗ («Тирзепатид аппка»).
 *
 * Копирайтинг про препарат правят юристы, поэтому он вынесен из JSX: правка
 * формулировки не должна требовать чтения разметки. Тексты онбординга — в
 * content/onboarding.ts, статьи — в content/articles.ts.
 */
export const brand = { name: "BioFlow", product: "Tirzepatide" } as const;

/** Экран 8 — главная, карточка товара. */
export const home = {
  title: "Tirzepatide",
  buy: "Купить",
  consult: "Получить бесплатную консультацию",
  benefitsTitle: "Преимущества",
  benefits: [
    { icon: "appetite", title: "Контроль аппетита" },
    { icon: "hunger", title: "Меньше чувства голода" },
    { icon: "weight", title: "Поддержка снижения веса" },
    { icon: "format", title: "Удобный формат применения" },
  ],
  personal: {
    title: "Персональный блок",
    goal: "Ваша цель",
    weight: "Ваш текущий вес",
    bmi: "BMI",
    edit: "Изменить данные",
    empty: "Расскажите о себе — и мы покажем ваш BMI и цель здесь.",
    fill: "Заполнить данные",
  },
  faqTitle: "FAQ",
  bottomCta: {
    title: "Остались вопросы?",
    body: "Получите бесплатную консультацию перед заказом.",
    button: "Получить консультацию",
  },
  soldOut: "Нет в наличии",
} as const;

/** FAQ — вопросы из ТЗ (экран 8); ответы нейтральные, без обещаний. */
export const faq = [
  {
    q: "Как быстро появляется эффект?",
    a: "Изменения происходят постепенно. В начале организм адаптируется к препарату, затем может снижаться аппетит и становиться проще контролировать питание. Результаты индивидуальны и могут отличаться.",
  },
  {
    q: "Как применяется тирзепатид?",
    a: "Препарат применяется по установленной схеме в соответствии с рекомендациями специалиста. Схему и дозировку подбирают индивидуально — уточните их на консультации перед началом применения.",
  },
  {
    q: "Есть ли побочные эффекты?",
    a: "Как и у любого препарата, побочные эффекты возможны. Чаще всего они связаны с пищеварением и проявляются в начале применения. При появлении нежелательных реакций обратитесь к специалисту.",
  },
  {
    q: "Как хранить препарат?",
    a: "В холодильнике при температуре от 2 до 8 °C, не замораживая и защищая от света. Точные условия хранения указаны в инструкции к вашей упаковке.",
  },
  {
    q: "Можно ли получить консультацию перед покупкой?",
    a: "Да, консультация бесплатная. Нажмите «Получить консультацию» — откроется чат, где вам ответят на вопросы о препарате, схеме применения и доставке.",
  },
] as const;

/** Экран 9 — оформление заказа. */
export const checkout = {
  title: "Оформление заказа",
  fields: {
    name: "Имя",
    phone: "Телефон",
    telegram: "Telegram",
    city: "Город",
    address: "Адрес / способ доставки",
    quantity: "Количество",
    promoCode: "Промокод",
    comment: "Комментарий (необязательно)",
  },
  hints: {
    telegram: "Для связи по заказу — подставили из вашего аккаунта.",
    address: "Адрес доставки или удобный способ: курьер, пункт выдачи, почта.",
    promoCode: "Скидку по промокоду менеджер учтёт при подтверждении заказа.",
  },
  total: "Итого",
  submit: "Оформить заказ",
  submitting: "Отправляем заказ…",
  legal: "Нажимая «Оформить заказ», вы соглашаетесь на обработку персональных данных для связи по заказу и доставки.",
  unavailable: "Этот вариант сейчас недоступен.",
  backToProduct: "Вернуться к Tirzepatide",
} as const;

/** Экран 10 — заказ оформлен. */
export const orderPlaced = {
  title: "Заказ получен ✓",
  body: "Мы получили вашу заявку и свяжемся с вами для подтверждения заказа и доставки.",
  numberLabel: "Номер заказа",
  track: "Отследить заказ",
  ask: "Задать вопрос",
} as const;

/** Экран 13 — профиль. */
export const profile = {
  dataTitle: "Мои данные",
  sex: "Пол",
  height: "Рост",
  weight: "Вес",
  bmi: "BMI",
  goal: "Главная цель",
  edit: "Редактировать",
  editTitle: "Мои данные",
  editSubtitle: "Данные помогают персонализировать информацию внутри приложения. BMI пересчитается автоматически.",
  save: "Сохранить",
  ordersTitle: "Мои заказы",
  ordersSubtitle: "Текущие и предыдущие заказы.",
  noOrders: "Заказов пока нет",
  allOrders: "Все заказы",
  moreTitle: "Дополнительно",
  support: "Поддержка",
  faq: "FAQ",
  admin: "Админка · заказы",
  notFilled: "не указано",
} as const;

export const legal = {
  disclaimer:
    "Результаты индивидуальны и могут отличаться. Информация в приложении носит ознакомительный характер и не заменяет консультацию специалиста. Перед применением ознакомьтесь с инструкцией.",
  copyright: "© 2026 BioFlow. Все права защищены.",
} as const;

/** Резервный товар на случай, когда API не ответил; совпадает с сидом. */
export const fallbackProduct = {
  id: "00000000-0000-0000-0000-000000000000",
  slug: "tirzepatide",
  title: "Tirzepatide",
  subtitle: "Поддержка снижения веса · раствор для инъекций",
  description: "",
  rating: { value: 0, count: 0 },
  variants: [
    {
      id: "tz-60",
      label: "Флакон 60 мг",
      strengthMg: 60,
      price: { amountMinor: 1_290_000, currency: "RUB" as const },
      available: true,
    },
  ],
  defaultVariantId: "tz-60",
  images: [{ src: "/media/hero.webp", alt: "Флакон BioFlow Tirzepatide 60 мг" }],
  maxQuantity: 5,
};

/** Product shot, когда у товара в БД нет фото. */
export const PRODUCT_SHOT = "/media/hero.webp";
